import { classNames } from "@ember-decorators/component";
import NotificationsButtonComponent from "select-kit/components/notifications-button";
import { pluginApiIdentifiers, selectKitOptions } from "select-kit/components/select-kit";
const TagNotificationsButton = dt7948.c(class TagNotificationsButton extends NotificationsButtonComponent {}, [pluginApiIdentifiers("tag-notifications-button"), selectKitOptions({
  showFullTitle: false,
  i18nPrefix: "tagging.notifications"
}), classNames("tag-notifications-button")]);
export default TagNotificationsButton;